<template>
  <v-container fluid>
    <v-row class="px-8">
      <v-col cols="3" class="pr-4 pl-3">
        <v-btn
          depressed
          color="primary"
          class="btn-add"
          @click="create"
        >
          <v-icon v-text="'fas fa-user-plus'"></v-icon>
          <span>Add Salon</span>
        </v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <TableDefault
      :headers="headers"
      :items="items"
      :totalPage="totalPage"
      :limit="limit"
      :currentPage="currentPage"
      @edit="getSalonEdit"
      @remove="remove"
      @editStatus="save"
      @changePage="changePage"
      @changeItemPerPage="changeItemPerPage"
    />
  </v-container>
</template>

<script>
import TableDefault from "@/components/tables/TableDefault";
import salonService from "@/services/salon";
export default {
  name: "Salon",
  components: { TableDefault },
  data: () => ({
    headers: [
      {
        text: "ID",
        field: "id"
      },
      {
        text: "Title",
        field: "title"
      },
      {
        text: "Date",
        field: "date"
      },
      {
        text: "Time",
        timeStart: "timeStart",
        timeEnd: "timeEnd"
      },
      {
        text: "Location",
        field: "location"
      },
      {
        text: "Activation",
        field: "active",
        checkbox: true,
        center: true
      },
      {
        text: "Action",
        action: true
      }
    ],
    items: [],
    totalPage: 1,
    currentPage: 1,
    limit: 50
  }),
  created() {
    this.getSalon();
  },
  methods: {
    changePage(page) {
      this.currentPage = page;
      this.getSalon();
    },
    changeItemPerPage(limit) {
      this.limit = limit;
      this.getSalon();
    },
    async getSalon() {
      let res = await salonService.getSalonPagination({
        limit: this.limit,
        currentPage: this.currentPage
      });
      if (res) {
        this.items = res.data.data;
        this.totalPage = res.data.totalPage;
      }
    },
    async save(item) {
      let res = await salonService.update(item);
      if(res) {
        const indexItem = this.items.findIndex(value => value.id === item.id);
        if(indexItem >= 0) {
          this.items[indexItem] = res.data;
        }
      }
    },
    create() {
      this.$store.dispatch('resetSalon');
      this.$router.push({ name: 'SalonCreate' })
    },
    getSalonEdit(salon) {
      this.$store.dispatch("setSalon", salon);
      this.$router.push({
        name: "SalonEdit"
      });
    },
    async remove(salon) {
      await this.$store.dispatch("removeSalon", salon);
      this.getSalon();
    }
  }
};
</script>
<style lang="sass">
.v-menu__content
    .v-card
        margin: 0
.radio-group .col
    padding: 0 12px
.v-input--selection-controls .v-radio>.v-label
    color: #000
    font-weight: 400
.v-input__control .v-input__slot
    min-height: 36px !important
    padding: 0 0px 0 8px
.v-input__icon
    height: 18px
</style>
